module.exports = {"id":"183526","name":"Nabil El Zhar","rating":"75","photo":"./data/images/photos/1/183526.png","club":{"name":"CD Leganés","logo":"./data/images/clubs/CDLeganes.png"},"positions":["MD","MOC","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NabilElZhar0.json
// module id = 3113
// module chunks = 0